import axios from 'axios';

const state = {
    invoice: "",
};

const getters = {
    
};

const actions = {
    bank_accounts_active() {
        return new Promise((resolve, reject) => {
            axios.get('bank-accounts')
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    invoice_download_pdf(_, data) {
        return new Promise((resolve, reject) => {
            axios.get('invoice/' + data.id + '/pdf', { responseType: 'blob' })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    invoice_renew_package({ commit }) {
        return new Promise((resolve, reject) => { 
            axios.post('invoice/renew-package')
            .then(response => {
                commit("PUSH_INVOICE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    invoice_pay({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('invoice/' + data.id + '/pay')
            .then(response => {
                commit("PUSH_INVOICE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    invoice_list({ commit }, data) {
        return new Promise((resolve, reject) => { 
            let url = 'invoices?page=' + (data.page || 1) + '&limit=' + (data.limit || 10)
            if (data.columnFilters) {
                url += '&columnFilters=' + encodeURIComponent(JSON.stringify(data.columnFilters))
            }
            axios.get(url)
            .then(response => {
                commit("PUSH_INVOICE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
}

const mutations = {
    PUSH_INVOICE(state, data){
        state.invoice = data
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

